@if (labelSpec$ | async; as labelSpec) {
  <div class="flex layout-col gap-sm">
    <mat-checkbox name="{{ name }}-label-enabled" [(ngModel)]="labelSpec.enabled">{{
      'labeling.enabled' | translate
    }}</mat-checkbox>
    <mat-form-field>
      <mat-label>{{ 'context.template' | translate }}</mat-label>
      <input
        matInput
        name="{{ name }}-label-template"
        placeholder="{{ 'context.template' | translate }}"
        [(ngModel)]="labelSpec.template"
      />
    </mat-form-field>
  </div>
}
